<template>
    <div class="modal fade show" style="display: block" tabindex="-1" role="dialog">
        <form @submit.prevent="$refs.imzalayici.sign()">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{translate('sign')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" :disabled="loading" :aria-label="translate('close')" @click="$emit('close')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <imzalayici
                        ref="imzalayici"
                        :style="[alertVisible ? {'height' : '530px'} : {'height' : '420px'}]"
                        :items="signingItems"
                        :identityNumber="identityNumber"
                        :processingMessage="processingMessage"
                        @onloading="imzalayiciOnLoading"
                        @completed="$emit('completed')"
                        @onerror="$emit('onerror')"
                        @imzalayiciNotFound="imzalayiciFoundStatus"
                    />
                </div>
                <div class="modal-footer footer-button-container-1">
                    <button type="button" class="btn btn-outline-secondary" :disabled="loading" @click="$emit('close')">{{translate('close')}}</button>
                    <button type="button" class="btn btn-danger" style="width:100px;" v-if="loading && !imzalayiciOnLoading" @click="cancel" data-dismiss="modal">{{translate('cancel')}}</button>
                    <button type="submit" class="btn btn-success" style="width:100px;" v-if="!loading && !imzalayiciNotFound">{{translate('eSign')}}</button>
                </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import imzalayici from '../components/Imzalayici.vue'

export default {
    components: {
        imzalayici
    },
    data() {
        return {
            loading: false,
            imzalayiciNotFound: false,
            }
    },
    computed:{
        alertVisible(){
            return window.settings.imzalayiciAlertVisible
        }
    },
    props: {
        signingItems: {
            type: Array,
            default: null,
            required: true
        },
        identityNumber: {
            type: String,
            required: true
        },
        processingMessage: {
            type: String,
            default: null
        }
    },
    methods: {
        imzalayiciOnLoading(e){
            console.log('onLoading: ', e);
            this.loading = e;
        },
        imzalayiciFoundStatus(e){
            this.imzalayiciNotFound = e
        },
        cancel(){
            this.$refs.imzalayici.cancel();
            this.loading = false;
        }
    }
}
</script>

<style scoped>
.footer-button-container-1{
    display: flex;
    align-items: center;
    justify-content: space-between !important;
}
</style>